import { Observable, of } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from '../environments/environment';

/**
 * Runs Google reCAPTCHA v3 when enabled; otherwise returns an empty token.
 * Backend must also have RECAPTCHA_ENABLED=false to skip verification.
 */
export function executeRecaptcha(
  recaptcha: ReCaptchaV3Service,
  action = 'submitForm'
): Observable<string> {
  if (!environment.recaptchaEnabled) {
    return of('');
  }
  return recaptcha.execute(action);
}
